<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-header-2">
                                <h5>Vendor Information</h5>
                            </div>
                            <v-form class="theme-form theme-form-2 mega-form" ref="form">
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">CIF</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="CIF" v-model="cif" ></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Name</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Name" v-model="name" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Address</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Address" v-model="address"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Address number</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Address number" v-model="addressnumber"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Country</label>
                                        <div class="col-sm-10">
                                            <v-combobox
                                                label="Search country..."
                                                :items="dataCountryCombo"
                                                item-title="name"
                                                item-value="id"
                                                v-model="country"
                                                variant="outlined"
                                            ></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Province</label>
                                        <div class="col-sm-10">
                                            <v-combobox
                                                label="Search province..."
                                                :items="dataProvinceCombo"
                                                item-title="name"
                                                item-value="id"
                                                v-model="province"
                                                variant="outlined"
                                            ></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">City</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="City" v-model="city"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Postal code</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Postal code" v-model="postalcode"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Email</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Email" v-model="email"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Phone</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Phone" v-model="phone"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">IBAN</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="IBAN" v-model="IBAN"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="d-flex flex-column">
                                    <v-btn class="mt-4" color="success" block @click="validate"> Create </v-btn>
                                </div>
                            </v-form>
                        </div>

                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'

export default {
    name: 'app',
    title: 'New vendor',
    watch: {
        country() {
            if(this.cargado){
                this.province=null
            }
            if(this.country && this.country.id){
                this.getListProvince(this.country.id)
            } 
            
        },
    },
    data() {
        return {
            cargado:false,
            id: null,
            cif: '',
            name: '',
            address: '',
            addressnumber: '',
            dataCountryCombo: [],
            country: '',
            dataProvinceCombo: [],
            province: '',
            city: '',
            postalcode: '',
            email: '',
            phone: '',
            IBAN: '',
            messageError: '',
            typeOfMessage: ''
        }
    },
    methods: {
        async validate() {
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                this.create()
            } else {
                alert('Faltan parametros')
            }
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        getListCountry() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/country/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataCountryCombo = []
                        self.dataCountryCombo = response.data

                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getListProvince(id) {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/country/' + id + '/provinces/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        self.dataProvinceCombo = []
                        self.dataProvinceCombo = response.data

                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        create() {
            let newObject = {
                cif: this.cif,
                name: this.name,
                address: this.address,
                addressnumber: this.addressnumber,
                city: this.city,
                postalcode: this.postalcode,
                email: this.email,
                phone: this.phone,
                IBAN: this.IBAN,
            }
            if(this.country && this.country.id){
                newObject.country_id = this.country.id
            }
            if(this.province && this.province.id){
                newObject.province_id = this.province.id
            }

             axios.post('http://localhost:8001/admin/vendor/create', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha creado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            })
        }
    },
    async created() {
        await this.getListCountry()
        this.cargado=true
    }
}
</script>

<style></style>
